import { gql } from "@apollo/client";

const LoginMutation = gql`
  mutation authenticate($email: String!, $password: String!) {
    authenticate(input: { temail: $email, tpassword: $password }) {
      jwt
    }
  }
`;

const hash = "a341f57b85e21022be3291893f66096bcd1f419a0140a4ebbb15a6e7fc5acdb9";

export { LoginMutation, hash };
